import { de } from './i18n/de';
import { frFr } from './i18n/frFr';
import { frBe } from './i18n/frBe';
import { Language } from './interfaces/language';

const languages: Record<string, Language | undefined> = {
    'fr-fr': frFr,
    'fr-be': frBe,
};

export const activeLanguage: Language = languages[new URLSearchParams(window.location.search).get('language') || ''] || de;
